var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8558 3.75609L18.2439 0.14415C18.1516 0.051881 18.0262 0 17.8955 0H0.492537C0.220657 0 0 0.220328 0 0.492537V21.5075C0 21.7797 0.220657 22 0.492537 22H21.5075C21.7793 22 22 21.7797 22 21.5075V4.10448C22 3.97346 21.9481 3.84836 21.8558 3.75609ZM5.91045 0.984746H16.0896V7.88027H5.91045V0.984746ZM18.0597 21.0146H3.9403V12.4773H18.0597V21.0146ZM21.0149 21.0146H19.0448V11.9847C19.0448 11.7125 18.8241 11.4922 18.5522 11.4922H3.44776C3.17588 11.4922 2.95522 11.7125 2.95522 11.9847V21.0146H0.985075V0.984746H4.92537V8.37281C4.92537 8.64501 5.14603 8.86534 5.41791 8.86534H16.5821C16.854 8.86534 17.0746 8.64501 17.0746 8.37281V0.984746H17.6916L21.0149 4.30806V21.0146Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/SaveIcon.c5bf868aa63776c8b8f54d4755789e82.svg";
export { ForwardRef as ReactComponent };